import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../context/LanguageContext';

export const StructuredData: React.FC = () => {
    const { language } = useLanguage();

    // Define language-specific content or default to structured data that covers both
    const isDe = language === 'de';

    const schema = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "ProfessionalService",
                "@id": "https://integrovaai.de/#organization",
                "name": "Integrova AI GmbH",
                "url": "https://integrovaai.de",
                "logo": "https://integrovaai.de/logo_icon_new.png",
                "image": "https://integrovaai.de/og-default.png",
                "description": isDe
                    ? "Strategische Enterprise-Lösungen für SAP, AI und Cloud-Transformation in München."
                    : "Strategic Enterprise Solutions for SAP, AI, and Cloud Transformation based in Munich.",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Münchener Straße",
                    "addressLocality": "Munich",
                    "postalCode": "80331",
                    "addressCountry": "DE"
                },
                "priceRange": "$$$",
                "telephone": "+49 89 123456789"
            },
            // Service 1: Software Asset Management (Explicit Link to Cost Reduction & VMware)
            {
                "@type": "Service",
                "serviceType": "Software Asset Management",
                "provider": { "@id": "https://integrovaai.de/#organization" },
                "name": isDe ? "Strategisches Software Asset Management" : "Strategic Software Asset Management",
                "description": isDe
                    ? "Reduzierung der OpEx um 30% durch VMware-Kostenoptimierung und Asset-Baselining."
                    : "Reduces OpEx by 30% through VMware cost optimization, Broadcom negotiation strategies, and asset baselining.",
                "offers": {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "License Defense Program",
                        "description": "Broadcom/VMware Cost Reduction & License Audit Defense"
                    }
                },
                "hasOfferCatalog": {
                    "@type": "OfferCatalog",
                    "name": "Cost Optimization Services",
                    "itemListElement": [
                        {
                            "@type": "Offer",
                            "itemOffered": {
                                "@type": "Service",
                                "name": "VMware Cost Reduction",
                                "keywords": "VMware, Broadcom, Virtualization Costs, OpEx Optimization"
                            }
                        },
                        {
                            "@type": "Offer",
                            "itemOffered": {
                                "@type": "Service",
                                "name": "Audit Defense",
                                "keywords": "Software Audits, Compliance, License Baseline"
                            }
                        }
                    ]
                },
                "areaServed": "DACH"
            },
            // Service 2: GRC & Compliance
            {
                "@type": "Service",
                "serviceType": "Governance, Risk & Compliance",
                "provider": { "@id": "https://integrovaai.de/#organization" },
                "name": "Enterprise Governance & Digital Resilience",
                "description": "DORA/NIS2 Compliance Framework implementation and automated regulatory reporting.",
                "offers": {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Officer Shield Program"
                    }
                }
            },
            // Service 3: ERP Modernization
            {
                "@type": "Service",
                "serviceType": "ERP Modernization",
                "provider": { "@id": "https://integrovaai.de/#organization" },
                "name": "Strategic ERP Modernization",
                "description": "Clean Core Strategy for SAP S/4HANA migration and legacy Z-Code decommissioning.",
                "offers": {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Clean Core Surgeon Program",
                        "keywords": "SAP S/4HANA, Clean Core, ABAP Decommissioning"
                    }
                }
            }
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};
